import { Banner } from "./Banner";
import { List } from "./List";

export const Service = () => <>
    <Banner />
    <List />
</>